module.exports = __webpack_public_path__ + "static/media/truck-yellow.2dd724a5.svg";